/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Box, Typography, Avatar, useTheme } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const ContactHeader = ({ contact = {} }) => {
	const name = contact?.Name ?? contact?.Addressee ?? '';
	const theme = useTheme();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 2,
				mb: 3,
				p: 2,
				borderRadius: 2,
				boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
				backgroundColor: theme.palette.action.hover,
			}}
		>
			<Avatar sx={{ width: 48, height: 48 }}>
				<AccountCircleIcon sx={{ fontSize: 32, color: 'white' }} />
			</Avatar>
			<Box>
				<Typography variant='h6' fontWeight='bold'>
					{name}
				</Typography>
				{contact.Email && (
					<Typography variant='body2' color='textSecondary' >
						{contact.Email}
					</Typography>
				)}
			</Box>
		</Box>
	);
};

export default ContactHeader;
